/**
 * Передача секрета ресурса в команду мимо Redux (RP-UA1a).
 *
 * RTK Query хранит аргументы мутации (`originalArgs`) в состоянии, и они
 * проходят через каждое middleware — в том числе через реестр хранения и
 * DevTools. Поэтому в аргументах мутации только ссылка `secretRef`, а значение
 * лежит здесь до первого чтения: `query` endpoint-а забирает его ОДИН раз и
 * кладёт в тело запроса, которое в состояние не попадает. Невостребованное
 * стирается при выходе пользователя (`forgetStashedSecrets`).
 */
const stash = new Map<string, string>()
let counter = 0

/** Отложить секрет для одной команды. Пустой секрет не откладывается: «не менять». */
export function stashSecret(secret: string | null): string | null {
  if (secret === null || secret === '') return null
  counter += 1
  const ref = `secret-${counter}`
  stash.set(ref, secret)
  return ref
}

/** Забрать секрет: второй вызов с той же ссылкой вернёт `undefined`. */
export function takeSecret(ref: string | null): string | undefined {
  if (ref === null) return undefined
  const value = stash.get(ref)
  stash.delete(ref)
  return value
}

/** Стереть отложенный секрет команды, если его никто не забрал (команда не ушла). */
export function discardSecret(ref: string | null): void {
  if (ref !== null) stash.delete(ref)
}

/** Стереть всё отложенное: выход пользователя, смена пользователя. */
export function forgetStashedSecrets(): void {
  stash.clear()
}

/** Для тестов: сколько секретов ждут отправки. */
export function stashedSecretCount(): number {
  return stash.size
}
